import React, { Component } from 'react';
// Composants
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Message } from 'semantic-ui-react';
// Librairies
import { connect } from 'react-redux';
import i18n from '../../../locales/i18n';
// Ressources
import { faPowerOff } from '@fortawesome/pro-solid-svg-icons';
// Services
import McpOrganizationsService from '../../../services/McpOrganizationsService';
// Utils
import DatesUtil from '../../../utils/DatesUtil';
import UsersUtil from '../../../utils/UsersUtil';

// Activation de l'accès des assistants IA (serveur MCP) par l'organisation, en plus du droit de sa licence. Le propriétaire et les admins
// activent (après avoir accepté l'avertissement) ou désactivent ; les membres voient l'état. L'état vient d'OrganizationPanel (mcpStatus),
// le rôle du store (il peut changer en temps réel)
class OrganizationMcpForm extends Component {
    state = {
        isAcknowledged: false,
        isConfirmingDisable: false,
        isLoading: false
    };

    render() {
        const { mcpStatus, isOnline, loginAsData, activeOrganization } = this.props;
        const { isAcknowledged, isConfirmingDisable, isLoading } = this.state;
        const { isLicensed, isEnabled, enabledDate, enabledBy } = mcpStatus;
        const canManage = UsersUtil.canManageOrganization(activeOrganization);
        const canEdit = canManage && !loginAsData;

        return (
            <>
                <p className='mcp-tokens-text'>
                    {i18n.t("Une fois l'accès activé, toute personne qui a accès à un projet de l'organisation, membre ou collaborateur invité sur ce projet, peut le consulter avec un assistant IA (Claude, ChatGPT…), en lecture seule. L'assistant voit les mêmes champs que cette personne dans Grality et ne peut rien modifier.")}
                </p>
                <p className='mcp-tokens-text'>
                    {i18n.t("Les données consultées sont transmises au fournisseur de l'assistant (par exemple Anthropic ou OpenAI) pour qu'il puisse répondre. Activez cet accès seulement si votre organisation l'accepte.")}
                </p>

                {isEnabled
                    ? <Message positive>
                        {enabledBy
                            ? i18n.t("Accès activé le {{date}} par {{name}}.", { date: DatesUtil.getFormattedLocaleDateString(enabledDate), name: enabledBy })
                            : i18n.t("Accès activé le {{date}}.", { date: DatesUtil.getFormattedLocaleDateString(enabledDate) })}
                    </Message>
                    : <Message info>{i18n.t("Accès désactivé : aucun assistant IA ne peut consulter les projets de l'organisation.")}</Message>}
                {isEnabled && !isLicensed &&
                    <Message warning>{i18n.t("La licence de l'organisation n'inclut plus ce droit : l'accès reste bloqué tant qu'elle n'est pas renouvelée.")}</Message>}

                {canManage && loginAsData && <Message info>{i18n.t("Ce réglage ne peut pas être modifié lorsqu'un administrateur est connecté en tant que cet utilisateur.")}</Message>}

                {canEdit && !isEnabled && isLicensed &&
                    <div className='mcp-organization-activation'>
                        <Checkbox
                            checked={isAcknowledged} onChange={(_, { checked }) => this.setState({ isAcknowledged: checked })}
                            label={i18n.t("J'ai compris que les données consultées par un assistant IA sont transmises à son fournisseur, et mon organisation l'accepte.")}
                        />
                        <Button type='button' color='green' disabled={!isAcknowledged || !isOnline || isLoading} loading={isLoading} onClick={() => this.setEnabled(true)}>
                            <FontAwesomeIcon icon={faPowerOff} style={{ marginRight: '8px' }} />{i18n.t("Activer")}
                        </Button>
                    </div>}
                {canEdit && isEnabled &&
                    <div className='mcp-organization-activation'>
                        {isConfirmingDisable
                            ? <>
                                <span>{i18n.t("Plus aucun assistant IA n'aura accès aux projets de l'organisation, quel que soit l'utilisateur. Les connexions sont conservées et retrouveront ces projets si vous réactivez l'accès.")}</span>
                                <div>
                                    <Button type='button' color='red' disabled={!isOnline || isLoading} loading={isLoading} onClick={() => this.setEnabled(false)}>{i18n.t("Confirmer")}</Button>
                                    <Button type='button' color='grey' onClick={() => this.setState({ isConfirmingDisable: false })}>{i18n.t("Annuler")}</Button>
                                </div>
                            </>
                            : <Button type='button' color='red' disabled={!isOnline} onClick={() => this.setState({ isConfirmingDisable: true })}>
                                <FontAwesomeIcon icon={faPowerOff} style={{ marginRight: '8px' }} />{i18n.t("Désactiver")}
                            </Button>}
                    </div>}
            </>
        );
    }

    setEnabled = (isEnabled) => {
        const { activeOrganization } = this.props;
        this.setState({ isLoading: true });
        McpOrganizationsService.setEnabled(activeOrganization.id, isEnabled, this.state.isAcknowledged).then(mcpStatus => {
            this.setState({ isLoading: false, isAcknowledged: false, isConfirmingDisable: false });
            if (mcpStatus) this.props.setMcpStatus(mcpStatus);
        });
    }
}

const mapStateToProps = (state) => {
    return {
        isOnline: state.isOnline,
        activeOrganization: state.activeOrganization,
        loginAsData: state.loginAsData
    };
};

export default connect(mapStateToProps)(OrganizationMcpForm);
